// API URL utility functions
export const getApiBaseUrl = () => {
  let baseUrl;
  
  // For development, always use localhost (prioritize development over env var)
  if (process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost') {
    baseUrl = 'http://localhost:5000/api';
  } else {
    // Check for environment variable for production
    if (process.env.REACT_APP_API_URL) {
      baseUrl = process.env.REACT_APP_API_URL;
    } else {
      // Fallback for production
      baseUrl = 'https://api.niswainfotech.com/api';
    }
  }
  
  // Ensure base URL doesn't have double /api
  // Remove trailing /api if it exists, then add it once
  baseUrl = baseUrl.replace(/\/api\/?$/, '');
  return `${baseUrl}/api`;
};

export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;
  
  // If it's already a full URL (including S3 URLs), return as-is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // For development, always use localhost (prioritize development over env var)
  if (process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost') {
    return `http://localhost:5000${imagePath}`;
  }
  
  // For production, use the production API
  return `https://api.niswainfotech.com${imagePath}`;
};

// New function to handle S3 image URLs
export const getS3ImageUrl = (imagePath) => {
  if (!imagePath) return null;
  
  // If it's an S3 URL, convert it to use our signed URL API
  if (imagePath.includes('s3.amazonaws.com') || imagePath.includes('s3.ap-south-1.amazonaws.com')) {
    // Extract the file path from the S3 URL
    const urlParts = imagePath.split('/');
    const bucketName = urlParts[2].split('.')[0]; // Extract bucket name
    const filePath = urlParts.slice(3).join('/'); // Get the file path
    
    // For now, we'll use a different approach - we'll create a proxy endpoint
    // that can handle S3 URLs by extracting the key and generating signed URLs
    const encodedUrl = encodeURIComponent(imagePath);
    return `${getApiBaseUrl()}/s3/proxy?url=${encodedUrl}`;
  }
  
  // For non-S3 URLs, use the regular getImageUrl function
  return getImageUrl(imagePath);
};

// Function to get signed URL for S3 images
export const getSignedImageUrl = async (imagePath) => {
  if (!imagePath) return null;
  
  // If it's an S3 URL, we need to get a signed URL
  if (imagePath.includes('s3.amazonaws.com') || imagePath.includes('s3.ap-south-1.amazonaws.com')) {
    try {
      // For now, we'll use a simple approach - create a proxy endpoint
      const encodedUrl = encodeURIComponent(imagePath);
      return `${getApiBaseUrl()}/s3/proxy?url=${encodedUrl}`;
    } catch (error) {
      console.error('Error getting signed URL:', error);
      return imagePath; // Fallback to original URL
    }
  }
  
  // For non-S3 URLs, return as-is
  return imagePath;
};

export const constructApiUrl = (endpoint) => {
  const baseUrl = getApiBaseUrl();
  return `${baseUrl}${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`;
};
